const puntosDetalles = {
    //Se dividirá entre el valor de soles o dolares dependiendo del tipo moneda del alojamiento
    soles: 600,
    dolares: 146,
    nombre_coins: "Bluecoins",
    porcentaje_descuento_total_alquiler: 10,
};

export default puntosDetalles;
